import React, { useState, useEffect } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import Avatar from '../../UI/avatar';
import Button from '../../UI/button';
import ThInputText from '../../forms/th-input-text';
import { useAuth } from '../../../contexts/AuthContext';
import { apiClient } from '../../../services/api/apiClient';

type Props = {};

const GeneralSettingsPage = (props: Props) => {
  const { user, refreshUser } = useAuth();
  const [username, setUsername] = useState(user?.username ?? '');
  const [email, setEmail] = useState((user as any)?.email ?? '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setUsername(user?.username ?? '');
    setEmail((user as any)?.email ?? '');
  }, [user]);

  const handleSave = async () => {
    if (!user) return;
    setSaving(true);
    setError(null);
    setSuccess(false);
    try {
      await apiClient.patch(`/users/${user._id}`, {
        username: username.trim() || undefined,
        email: email.trim() || undefined
      });
      setSuccess(true);
      refreshUser();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to save changes');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Form>
      <div className='settings-main-avatar'>
        <Avatar size='xxl' />
        <div className='settings-main-actions'>
          <Button
            px={30}
            variant='outline-dark'
          >
            Add New Picture
          </Button>
          <Button
            px={30}
            variant='outline-primary'
          >
            Delete
          </Button>
        </div>
      </div>
      <div className='settings-main-content'>
        <ThInputText
          label='Username'
          value={username}
          onChange={(v: string) => setUsername(v)}
          mb={16}
        />
        <ThInputText
          mb={16}
          label='Email Address'
          value={email}
          onChange={(v: string) => setEmail(v)}
        />
      </div>
      {error && <p className='text-danger small'>{error}</p>}
      {success && (
        <p className='text-success small'>Changes saved successfully.</p>
      )}
      <div className='d-flex justify-content-end'>
        <Button
          variant='primary'
          px={30}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? (
            <Spinner
              size='sm'
              animation='border'
            />
          ) : (
            'Save Changes'
          )}
        </Button>
      </div>
    </Form>
  );
};

export default GeneralSettingsPage;
